// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1z9FB","header":"MessagesList_header__2j_uq","chat":"MessagesList_chat__2Q3co"};